import { useMemo } from "react";
import { AllSeriesType, LineSeriesType } from "@mui/x-charts-premium";
import { MathUtils } from "shared-ts-utils-core";
import { merge } from "lodash";
import { DurationSeries } from "firefly-shared-ts-timeseries";
import { MuiDurationSeriesOptions } from "./DurationSeriesMuiChart";

export const useSeries = (
  durationSeries: Array<DurationSeries<number | null>> | undefined,
  durationSeriesOptions?: Array<MuiDurationSeriesOptions>
): Array<AllSeriesType> => {
  return useMemo(() => {
    if (durationSeries === undefined) {
      return [];
    }
    return durationSeries.map((series, seriesIndex) => {
      const data = series.points.map((point) => point.value);
      const defaultOptions: LineSeriesType = {
        id: series.info.id,
        type: "line",
        showMark: false,
        label: series.info.displayName,
        data: data,
        valueFormatter: (value) => {
          return value == null
            ? null
            : `${MathUtils.round(value)} ${series.info.unit}`;
        },
      };
      const options = durationSeriesOptions?.[seriesIndex];

      return merge(defaultOptions, options);
    });
  }, [durationSeries, durationSeriesOptions]);
};
